type Listener = (generation: number) => void;

const listeners = new Set<Listener>();

/** Monotonic counter — survives missed events while a tab was unmounted. */
let refreshGeneration = 0;

export function getDashboardRefreshGeneration(): number {
  return refreshGeneration;
}

/**
 * Notify Home / Spend to force-pull analytics (after import / WS complete).
 * Bumps generation so late-mounted screens still refetch.
 */
export function notifyDashboardRefresh(reason?: string): void {
  refreshGeneration += 1;
  const generation = refreshGeneration;
  console.info('[dashboardRefreshBus] 🔄 force refresh', { generation, reason });
  listeners.forEach((listener) => {
    try {
      listener(generation);
    } catch (error) {
      console.error('[dashboardRefreshBus] listener error', error);
    }
  });
}

export function subscribeDashboardRefresh(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
